<template>
  <form-layout :title="data.question.node.title" :nameLink="'Information complémentaire'" :href="'/info/' + content.slug" :hasLink="data.question.node._id === 1">

    <slot>

      <!-- Liste des questions -->
      <ul>
        <choice v-for="(answer, index) in data.question.node.answers.edges"
                :key="index"
                :type="data.question.node.type"
                :answer="answer"
                :idBtn="answer.node._id"
                :answerSelected="data.answerSelected"
        />
      </ul>

      <div class="u-color--red prevent-error" v-if="submitted && error">
        <img src="@/assets/img/icons.svg#icon-error" width="20" height="20">
        <span>{{error}}</span></div>

      <div class="col-12 d-flex justify-content-center button">
        <v-button-round :text="'Valider'" class="u-bg--blue" @click.native="validateForm()"/>
      </div>

      <div v-if="data.question.node.seeMoreContent" class="col-12 d-flex justify-content-center">
        <link-info v-if="content.slug" :text="'Information complémentaire'" :nameLink="'Information complémentaire'" :href="'/info/' + content.slug" class="link-eval u-color--blue"/>
      </div>

      <!-- Bookmarks -->
      <div class="case" v-if="bookmarks && bookmarks.edges.length">
        <title-simple :text="'Ou choisir un cas fréquent :'"/>
        <ul>
          <li v-for="(bookmark, index) in bookmarks.edges" :key="index"><link-arrow :text="bookmark.node.title" class="link u-color--blue" :href="bookmark.node.anchorHref"/></li>
        </ul>
      </div>

    </slot>

  </form-layout>
</template>

<script>
  import FormLayout from './../Layout/FormLayout';
  import VButtonRound from "./../Core/RoundButton";
  import Choice from './Parts/Choice/Choice'
  import { mapGetters, mapActions } from 'vuex'
  import TitleSimple from "../Core/TitleSimple";
  import LinkArrow from "../Core/Link/LinkArrow";
  import gql from 'graphql-tag'
  import LinkInfo from "../Core/Link/LinkInfo";

  export default {
    name: "VForm",
    components: {LinkInfo, LinkArrow, TitleSimple, VButtonRound, Choice, FormLayout},
    apollo: {
      content: {
        skip() {
          if(!this.idSeeMore) {
            return true
          }
        },
        query: gql` query content($id: ID) {
          content(id: $id) {
            slug
          }
        }`,
        variables() {
          // Use vue reactive properties here
          return {
            id: 'api/v1/contents/' + this.idSeeMore
          }
        },
      }
    },

    data: () => {
      return {
        submitted: false,
        error: '',
        idSeeMore: false,
        content: ''
      }
    },
    computed: {
      ...mapGetters({
        answerSelected: 'getAnswerSelected',
        getCurrentQuestionId: 'getCurrentQuestionId'
      })
    },
    methods: {
      ...mapActions({
        setCurrentQuestionId: 'setCurrentQuestionId'
      }),
      validateForm() {
        this.submitted = true
        let query = {}
        let answerSelected = this.answerSelected

        if (!answerSelected || (Array.isArray(answerSelected) && !answerSelected.length)) {
          if (!Object.keys(answerSelected).length) {
            this.error = "Veuillez selectionner au moins une valeur"

            return false
          }
        }

        this.error = false

        Object.keys(this.$route.query).map(key => {
          query[key] = this.$route.query[key]
        })

        query[`q${this.getCurrentQuestionId}`] = this.answerSelected

        this.nextQuestion = window.execute(answerSelected, query)

        if (!this.nextQuestion) {
          query['reco'] = false
        } else if (this.nextQuestion.type === 'question') {
          query[`q${this.nextQuestion.id}`] = false
        } else {
          query['reco'] = this.nextQuestion.id
        }

        this.$router.push({ name: 'recommendation_pathology', query: query })

        window.scroll(0, 200);
      }
    },

    props: ['data', 'bookmarks'],

    mounted() {
      if (this.data.question.node.seeMoreContent) {
        this.idSeeMore = this.data.question.node.seeMoreContent._id
      }

      window.scroll(0, 200);
    }
  }
</script>

<style lang="scss">
.link-eval {
  margin-top: rem(10px);
}



    .modal-contact .u-bg--blue {

    	background-color:#ff5e5b;

    	&:hover,
    	&:focus{background-color:#FF505B!important}

    }

</style>
